import React from 'react'
import { Typography } from 'antd'
import { size } from 'lodash'
import PropTypes from 'prop-types'

import { StyledSearchHighlightedSpan } from '../styled'

const TreeSelectNodeTitle = ({
  title,
  isIgnored,
  isSticky,
  isDisabled,
  searchValue,
}) => {
  const className = `${isIgnored ? 'is-ignored ' : ''}${
    isSticky ? 'is-sticky' : ''
  }`
  if (!searchValue) {
    return (
      <div className={className}>
        <Typography.Text disabled={isDisabled}>{title}</Typography.Text>
      </div>
    )
  }

  const startIndex = title.toLowerCase().indexOf(searchValue.toLowerCase())
  const endIndex = startIndex + size(searchValue)

  return (
    <div className={className}>
      {startIndex !== 0 && (
        <Typography.Text disabled={isDisabled}>
          {title.substring(0, startIndex)}
        </Typography.Text>
      )}
      <StyledSearchHighlightedSpan disabled={isDisabled}>
        {title.substring(startIndex, endIndex)}
      </StyledSearchHighlightedSpan>
      {endIndex < size(title) && (
        <Typography.Text disabled={isDisabled}>
          {title.substring(endIndex, size(title))}
        </Typography.Text>
      )}
    </div>
  )
}

TreeSelectNodeTitle.propTypes = {
  title: PropTypes.string,
  isSticky: PropTypes.bool,
  searchValue: PropTypes.string,
  isIgnored: PropTypes.bool,
  isDisabled: PropTypes.bool,
}

TreeSelectNodeTitle.defaultProps = {
  title: '',
  isSticky: false,
  searchValue: null,
  isIgnored: false,
  isDisabled: false,
}

export default TreeSelectNodeTitle
